<template>
    <div>
        <v-text-field
                v-model="color"
                v-mask="mask"
                outlined
                dense
                :readonly="readonly"
                :color="input_color"
                :background-color="input_background_color"
                @click="menu = true"
                :clearable="!readonly"
                hide-details="auto"
        >
            <template v-slot:append>
                <v-menu
                        v-model="menu"
                        :disabled="readonly"
                        top
                        nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle" v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="color" show-swatches flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </template>
        </v-text-field>

        <input type="hidden"/>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
        },
        readonly: Boolean,
    },
    data() {
        return {
            color: "#FFFFFF",
            mask: "!#XXXXXX",
            menu: false,
        };
    },
    watch: {
        value(val) {
            this.color = val;
        },
        color(val) {
            if ((typeof val == "string")) {
                this.$emit("input", val);
            } else {
                this.$emit("input", '#FFFFFF');
            }
        },
    },
    mounted() {
        this.color = this.value;
    },
    computed: {
        swatchStyle() {
            const {color, menu} = this;
            return {
                backgroundColor: color,
                cursor: "pointer",
                height: "25px",
                width: "60px",
                borderRadius: menu ? "50%" : "4px",
                transition: "border-radius 200ms ease-in-out",
            };
        },
    },
};
</script>